import Header from "../../components/Header/Header";
import iconTelWhite from "../../assets/icon_tel_wh.svg";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import useSelectBrandId from "#features/Giftcard/hooks/useSelectBrand";
import useSelectBrand from "#hooks/styles/useSelectBrand";
import useReactGASend from "../../hooks/useReactGASend";
import { GiCheckMark } from "react-icons/gi";
import React from "react";


const common = [
  {
    title: "분실물은 어떻게 신고하나요",
    content: "랜더스필드에서 습득된 유실물은 랜더스센터에서 보관됩니다. \n\n 분실물이 있으신 경우 랜더스 고객센터, 또는 랜더스 APP 1:1문의를 남겨주시면 습득물 확인 후 안내 도와드릴 수 있습니다. \n\n※ 유실물 문의 시 분실 날짜, 분실물 특징(물품, 색상, 브랜드, 모양)에 대해 남겨주시면 습득된 유실물 확인 후 안내 도와 드리겠습니다. \n※ 유실물은 랜더스센터에 습득된 경우에만 확인 가능하며, 습득 일로부터 30일간 보관됩니다.\n[SPACE]*습득 일로부터 30일이 초과된 유실물은 폐기, 또는 경찰서 유실물 센터로 인계될 수 있습니다." ,
    reference: "",
  },
  {
    title: "습득 확인된 분실물은 어떻게 찾나요?",
    content: "고객센터를 통해 확인된 유실물은 랜더스필드 내 위치한 랜더스센터에서 찾으실 수 있습니다. \n\n ※ 랜더스센터는 홈경기 진행 시에만 운영됩니다. \n[SPACE] - 랜더스센터 운영시간 : 게이트 오픈 ~ 경기 종료 시까지 \n※ 습득 일로부터 30일 이내 찾아가지 않을 시 폐기, 또는 경찰서 유실물 센터로 인계될 수 있습니다.\n※ 홈경기 미진행, 또는 경기장 오픈 시간 이전/이후에는 유실물 수령이 어렵습니다",
    reference: ""
  }
];


const ICON_MAP = {
  check: <GiCheckMark className="inline-block mr-1"/>
}

const formatText = (text) => {
  return text.split("\n").map((line, index) => {
    const elements = [];

    let rest = line;

    // 1. 앞에 [SPACE]가 몇 개 있는지 계산
    const spaceMatches = rest.match(/^(\[SPACE])+/);
    if (spaceMatches) {
      const count = spaceMatches[0].match(/\[SPACE\]/g).length;
      for (let i = 0; i < count; i++) {
        elements.push(<span key={`space-${i}`} className="pl-2" />);
      }
      rest = rest.replace(/^(\[SPACE\])+/,"").trim();
    }

    // 2. 아이콘 처리
    const iconMatch = rest.match(/\[ICON:(.+?)\]/);
    if (iconMatch) {
      const iconKey = iconMatch[1];
      elements.push(
        <span key="icon" className="inline-flex items-baseline pt-1">
          {ICON_MAP[iconKey]}
        </span>
      );
      rest = rest.replace(iconMatch[0], "").trim();
    }

    // 3. 텍스트
    elements.push(<span key="text">{rest}</span>);

    return (
      <div key={index} className="flex items-start">
        {elements}
        {index < text.split("\n").length - 1 && <br />}
      </div>
    );
  });
};

export const AccordionItemComponent = ({
  item,
  index,
}) => (
  <AccordionItem
    key={index}
    itemKey={index}
    className="mb-2"
    header={({state}) => 
      <div className={`flex items-center w-full pb-2 text-lg font-semibold text-gray-950 border border-[#D1D5DB] p-2.5 bg-white text-left ${state.isEnter ? 'rounded-bl-none rounded-br-none rounded-tl-[30px] rounded-tr-[30px] border-none' : 'rounded-full'}`}>
        <span
          className={`inline-flex items-center justify-center p-3 h-10 bg-black shadow-md rounded-full text-white text-2xl font-semibold shrink-0 mr-2`}
        >
          Q
        </span>
        {item.title}
      </div>
    }
  >
  {({state}) => 
    <div className={`p-6 border rounded-3xl border-[#D1D5DB] bg-white ${state.isEnter && 'rounded-tl-none rounded-tr-none border-none mt-[-10px]'}`}>
      <p className="font-medium text-gray-950">{formatText(item.content)}</p>
      {item.buttons && (
        <div className="flex justify-center flex-col">
          {item.buttons.map(button => (
            <LinkItem
              title={button.title}
              url={button.link}
              styles={"mx-6"}
            />
          ))}
        </div>
      )}
    </div>
  } 
  </AccordionItem>
);


export const LinkButton = ({
  url,
  className,
  imgSrc,
  altText,
  buttonText,
  onClick,
}) => (
  <a
    onClick={onClick}
    href={url}
    className={className}
  >
    <span className="shrink-0">
      <img src={imgSrc} alt={altText} />
    </span>
    <span className="flex-1 text-center">{buttonText}</span>
  </a>
);

export const LinkItem = ({ title, url, isPhoneLink, onClick, styles }) => (
  <li className="pt-4 list-none">
    <a
      onClick={onClick}
      href={url}
      target={isPhoneLink ? undefined : "_blank"}
      rel={isPhoneLink ? undefined : "noopener noreferrer"}
      className={`flex items-center bg-[#FFFFFF] ${
        isPhoneLink ? "gap-4" : ""
      } justify-center h-12 rounded-[16px] ${
        isPhoneLink ? "border-2" : "border"
      } border-[#FFA2A2] text-[#CE152D] font-semibold ${styles}`}
    >
      {isPhoneLink && <img alt="상담원 연결 전화 아이콘" />}
      {title}
    </a>
  </li>
);


const LostFoundPage = () => {
  const { makeEventTrackFn } = useReactGASend();
  const trackButtonClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };

  return (
    <section className="p-hasHeader">
      <Header title="분실물" />
      <div className="bg-white p-7 rounded-3xl mb-6 font-medium text-base mt-2 text-gray-950">
        <div>유실물 확인은 SSG랜더스 고객센터, 또는 랜더스 APP 1:1 문의로 분실 날짜, 분실물 특징(색상, 브랜드, 모양)에 대해 남겨주시면 확인 후 답변 드릴 수 있습니다.</div>
        <br />
        <div>(예시)</div>
        <div>9/19 빨간색 카드지갑, 내용물(SSG카드, 운전면허증(김랜디))</div>
        <br />
        <div>※ 습득된 유실물은 랜더스센터에 습득된 경우에만 확인 가능하며, 습득 후 30일간 보관됩니다.</div>
        <div>*30일 초과된 유실물은 폐기, 또는 경찰서 유실물 센터로 인계될 수 있습니다.</div>
        <div>※ 유실물의 습득 확인 시 홈경기가 있는 날 경기장 입장 가능시간에 랜더스센터에서 수령 가능합니다.</div>
        <div>*랜더스센터 위치 : 랜더스 필드 1층 의무실 앞 방면</div>
        <div>*홈경기가 없는 날은 랜더스센터가 운영되지 않습니다.</div>
      </div>

      <Accordion transition transitionTimeout={250}>
        {common.map((item, index) => (
          <AccordionItemComponent
            key={index}
            item={item}
            index={index}
          />
        ))}
      </Accordion>

      <div className="flex flex-col items-center mt-10 bg-white p-5 rounded-3xl justify-center w-full ">
        <div className="text-base font-medium text-[#4A5565] pb-2 flex text-center justify-center">추가적인 도움이 필요하신가요?</div>
        <LinkButton
          url="tel:032-455-2600"
          className="flex items-center justify-between w-36 h-9 bg-brand-secondary rounded-[30px] text-white px-6 py-6 text-sm font-medium mb-1.5"
          imgSrc={iconTelWhite}
          buttonText="전화상담"
          onClick={() => trackButtonClick("분실물_전화상담")}
        />
      </div>
    </section>
  );
};

export default LostFoundPage;
